import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "../dashboard/Dashboard";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import Troubleshoot from "../MonitoringTool/Troubleshoot";
import PageNotFound from "../OtherComponents/PageNotFound";

const MainRouter = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route exact path="/troubleshoot" element={<Troubleshoot />} />
          <Route exact path="/home" element={<Dashboard />} />
          <Route path="/" element={<Dashboard />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </div>
  );
};

export default MainRouter;
